import store from '@/store';
import customSettings from '@/model/userCustomSettings';

const countToMark = 10;

export function isVisitedEnough(name) {
  const visitCount = store.state.auth.user?.customSettings?.newPagesVisited?.[name];
  return visitCount > countToMark;
}

export function markVisited(name) {
  const newPagesVisited = store.state.auth.user?.customSettings?.newPagesVisited ?? {};
  const visitCount = newPagesVisited?.[name] ?? 0;

  if (visitCount > countToMark) return;

  newPagesVisited[name] = visitCount + 1;
  customSettings.set({ newPagesVisited });
}
